import { h, FunctionalComponent } from 'preact'
import cn from 'classnames'
import { Loader } from '../Loader'
import s from './Notice.css'

interface iProps {
  className?: string
}

const Notice: FunctionalComponent<iProps> = ({ className, children }) => {
  return (
    <div className={cn(s.Notice, className)}>
      <Loader
        className={s.Notice__loader}
        color="dark"
      />
      {children}
    </div>
  )
}

export default Notice
